export default __webpack_public_path__ + "static/media/key.566b7e77.svg";